module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.13/frontend/_next/static/images/yandex-station-325817c2d8ef40cc3522d60cbc7b328d.png";